import _ from 'lodash';

export const mapFields = (
  object: Record<any, any>,
  mapping: Record<any, any>,
): Record<any, any> =>
  _.reduce(
    mapping,
    (res, v, k) => {
      if (_.isNil(object)) {
        return res;
      }
      if (typeof v === 'function') {
        _.set(res, k, v(object));
      } else if (!_.isNil(v) && typeof v === 'object') {
        _.set(res, k, mapFields(object, mapping[k]));
      } else {
        _.set(res, k, _.get(object, v, null));
      }
      return res;
    },
    {},
  );

// fdp balances are represented in cents
export const convertCentsAmountToDollarsAmount = (amount) =>
  amount ? amount / 100 : 0;
